import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";
import Spinner from "components/ui/Spinner";

const AlarmPages = lazy(() => import("./Alarm"));

export function AlarmPage() {
  return (
    <>
      <Suspense>
        <AlarmPages />
      </Suspense>
    </>
  );
}

export default AlarmPage;
